import { useBaseAppDevStore } from "../stores/index.js";
import {
  errorMsg,
  getValueFromObject,
  msgData,
  validateAndUpdateVariable
} from "./utils.js";

function getVariableDef(key) {
  let { getVariableDefinition } = useBaseAppDevStore.getState();
  return getVariableDefinition(key);
}

export const getAppVariable = (data) => {
  try {
    const { key } = data;
    const value = useBaseAppDevStore.getState().getVariable(key);
    return msgData(data, {
      value
    });
  } catch (e) {
    return errorMsg(data, e);
  }
};

export const setAppVariable = (data) => {
  try {
    const { key, value } = data;
    let args = {
      getVariable: useBaseAppDevStore.getState().getVariable,
      setVariable: useBaseAppDevStore.getState().updateVariables
    };

    let resp;

    if (typeof key === "string") {
      resp = validateAndUpdateVariable({
        variableName: key,
        value,
        varDef: getVariableDef(key),
        ...args
      });
    } else if (typeof key === "object") {
      resp = Object.entries(key).reduce((acc, [key, value]) => {
        let res = validateAndUpdateVariable({
          variableName: key,
          value,
          varDef: getVariableDef(key),
          ...args
        });

        return { ...acc, ...res };
      }, {});
    }

    return msgData(data, {
      ...resp
    });
  } catch (e) {
    return errorMsg(data, e);
  }
};

export function getAppVariableSync(data, atomics) {
  try {
    let { key, path } = data;

    path.push(key);
    let [variableName, ...nestedPath] = path;

    let parentValue = useBaseAppDevStore.getState().getVariable(variableName);
    let value = getValueFromObject(parentValue, nestedPath);

    let response = msgData(data, {
      value
    });

    atomics.store(response);
  } catch (e) {
    let error = errorMsg(data, e);
    atomics.store(error);
  }
  atomics.notify();
  return;
}

export const setAppVariableSync = (data, atomics) => {
  try {
    const { key, value, path } = data;

    path.push(key);
    let [variableName, ...restNestedKeys] = path;

    let updatedValue = validateAndUpdateVariable({
      variableName: variableName,
      value,
      varDef: getVariableDef(variableName),
      nestedPath: restNestedKeys,
      getVariable: useBaseAppDevStore.getState().getVariable,
      setVariable: useBaseAppDevStore.getState().updateVariables
    });

    let response = msgData(data, { ...updatedValue });
    atomics.store(response);
  } catch (e) {
    let error = errorMsg(data, e);
    atomics.store(error);
  }

  atomics.notify();
  return;
};
